import { useContext, useEffect, useState } from 'react';
import Button from '../../../../components/Button/Button';
import Modal from '../../../../components/Modal/Modal';
import api from '../../../../js/api';
import './Bingo.scss';
import { UserContext } from '../../../../js/UserContext';
import { useParams, useSearchParams } from 'react-router-dom';
import { base64ToBlob, compressImage, request_image } from '../../../../js/utils';

export default function Challenge({ data, className }) {
    /**
     * Challenge component for the Bingo game.
     */

    useEffect(() => {
        setCompleted(data.completed || false);
    }, []);
    const { user, loading } = useContext(UserContext);
    const { roomNumber } = useParams();
    const s_params = useSearchParams();

    const login_spy = s_params[0].get('login');


    const [completed, setCompleted] = useState(false);
    if (!data || !data.challenge) {
        console.error('Invalid challenge data:', data);
        return <p>Error: Invalid challenge data.</p>;
    }


    const buttons = {
        complete:
            <Button text="Complete" onClick={async () => {
                const confirm = window.confirm(`Are you sure you want to mark the challenge "${data.challenge.title}" as completed?`);
                if (!confirm)
                    return console.log('Challenge completion cancelled by user.');

                if (!data.challenge.image_required) {
                    // If no image is required or an image is already provided, mark the challenge as completed
                    const response = await api.put(`/users/${user.login}/rooms/${roomNumber}/challenges/${data.challenge.id}`, {
                        completed: true,
                    });

                    if (response && response.error) {
                        console.error('Error completing challenge:', response.error);
                        alert(response.error);
                        return;
                    }
                    setCompleted(true);
                    return;
                }
                request_image(async (image) => {
                    if (!image)
                        return console.error('No image provided for challenge completion.');

                    const img_small = await compressImage(image, 1024, 0.8);

                    const r = await api.postFormData(`/users/${user.login}/rooms/${roomNumber}/challenges/${data.challenge.id}/image`, {
                        image: img_small,
                    });
                    if (r.status === 413)
                        return alert('Image is too large. Please use a smaller image.');
                    if (r.status !== 200) {
                        console.error('Error uploading image:', r);
                        alert(`Error ${r.status}: ${r.statusText}`);
                        return;
                    }
                    if (r && r.error) {
                        console.error('Error uploading image:', r.error);
                        alert(r.error);
                        return;
                    }
                    if (r && r.message)
                        alert(r.message);

                    console.log('Image uploaded successfully');
                    setCompleted(true);
                });

            }} />,
        incomplete:
            <Button text="Incomplete" onClick={async () => {
                const confirm = window.confirm(`Are you sure you want to mark the challenge "${data.challenge.title}" as incomplete?`);
                if (!confirm)
                    return console.log('Challenge incompletion cancelled by user.');
                const response = await api.put(`/users/${user.login}/rooms/${roomNumber}/challenges/${data.challenge.id}`, {
                    completed: false
                });
                if (response && response.error) {
                    console.error('Error marking challenge as incomplete:', response.error);
                    alert(response.error);
                    return;
                }
                setCompleted(false);
            }} />,
        view_image:
            <Button text="View Image" onClick={async () => {
                const l = login_spy || user.login;
                const response = await api.get(`/users/${l}/rooms/${roomNumber}/challenges/${data.challenge.id}/image`, {
                    silent: true,
                });

                if (!response)
                    return alert('No image available for this challenge.');
                if (response.error) {
                    console.error('Error fetching image:', response.error);
                    return alert(response.error);
                }
                if (!response.image)
                    return alert('No image available for this challenge.');

                if (response.status && response.status !== 200) {
                    console.error('Error fetching image:', response);
                    return alert(`Error ${response.status}: ${response.statusText}`);
                }


                const mime = "image/jpg";
                const blob = base64ToBlob(response.image, mime);
                const imageUrl = URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = imageUrl;
                link.download = `bingo-challenge-${data.challenge.id}.jpg`;
                link.click();

            }} />,
    }

    return (
        <div className={`bingo-challenge ${className} ${completed ? 'challenge-completed' : ''}`}>
            <Modal text={data.challenge.title}>
                <div className='bingo-challenge-content'>
                    <h2>{data.challenge.title}</h2>
                    <br />
                    <p>{data.challenge.description}</p>
                    <br />
                    <hr />
                    <div className='flex flex-row flex-center gap'>
                        {!login_spy ? (
                            completed ? buttons.incomplete : buttons.complete
                        ) : (
                            null
                        )}
                        {completed ? buttons.view_image : null}
                    </div>

                </div>
            </Modal>
        </div>
    );
}